module.exports = __webpack_public_path__ + "img/fzlc.c507ece3.jpg";